import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      home: 'Home',
      products: 'Products',
      subscriptions: 'Subscriptions',
      track: 'Track',
      orders: 'Orders',
      profile: 'Profile',
      cart: 'Cart',

      // Home
      welcome: 'Welcome',
      categories: 'Categories',
      popularProducts: 'Popular Products',
      viewAll: 'View All',
      shopByCategory: 'Shop by Category',

      // Products
      addToCart: 'Add to Cart',
      subscribe: 'Subscribe',
      outOfStock: 'Out of Stock',
      searchProducts: 'Search products...',
      allCategories: 'All Categories',
      noProducts: 'No products found',
      price: 'Price',
      mrp: 'MRP',
      off: 'OFF',

      // Cart
      yourCart: 'Your Cart',
      emptyCart: 'Your cart is empty',
      startShopping: 'Start shopping to add items',
      subtotal: 'Subtotal',
      deliveryFee: 'Delivery Fee',
      total: 'Total',
      placeOrder: 'Place Order',
      free: 'FREE',
      item: 'item',
      items: 'items',
      remove: 'Remove',
      selectDeliverySlot: 'Select Delivery Slot',

      // Subscriptions
      mySubscriptions: 'My Subscriptions',
      noSubscriptions: 'No active subscriptions',
      active: 'Active',
      paused: 'Paused',
      cancelled: 'Cancelled',
      pauseSubscription: 'Pause',
      resumeSubscription: 'Resume',
      cancelSubscription: 'Cancel',

      // Orders
      myOrders: 'My Orders',
      noOrders: 'No orders yet',
      orderNumber: 'Order',
      delivered: 'Delivered',
      confirmed: 'Confirmed',
      outForDelivery: 'Out for Delivery',
      pending: 'Pending',
      paymentMode: 'Payment Mode',
      cashOnDelivery: 'Cash on Delivery',
      onlinePayment: 'Online Payment',

      // Tracking
      trackOrder: 'Track Order',
      noActiveDelivery: 'No Active Delivery',
      noActiveDeliveryDesc: "You don't have any orders out for delivery right now.",
      refresh: 'Refresh',
      yourDeliveryPartner: 'Your delivery partner',

      // Profile
      myProfile: 'My Profile',
      editProfile: 'Edit Profile',
      saveProfile: 'Save Profile',
      walletBalance: 'Wallet Balance',
      loyaltyPoints: 'Loyalty Points',
      manageAddresses: 'Manage Addresses',
      addEditAddresses: 'Add or edit delivery addresses',
      logout: 'Logout',
      logoutConfirm: 'Are you sure you want to logout?',

      // Addresses
      myAddresses: 'My Addresses',
      addAddress: 'Add New Address',
      editAddress: 'Edit Address',
      noAddresses: 'No saved addresses',
      addFirstAddress: 'Add your first delivery address',
      fullAddress: 'Full Address',
      landmark: 'Landmark',
      city: 'City',
      pincode: 'Pincode',
      state: 'State',
      setDefault: 'Set Default',
      defaultAddress: 'Default',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      cancel: 'Cancel',

      // Common
      loading: 'Loading...',
      error: 'Something went wrong',
      success: 'Success',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      language: 'Language',
    },
  },
  hi: {
    translation: {
      // Navigation
      home: 'होम',
      products: 'प्रोडक्ट',
      subscriptions: 'सब्सक्रिप्शन',
      track: 'ट्रैक',
      orders: 'ऑर्डर',
      profile: 'प्रोफ़ाइल',
      cart: 'कार्ट',

      // Home
      welcome: 'स्वागत है',
      categories: 'श्रेणियाँ',
      popularProducts: 'लोकप्रिय प्रोडक्ट',
      viewAll: 'सभी देखें',
      shopByCategory: 'श्रेणी के अनुसार खरीदें',

      // Products
      addToCart: 'कार्ट में डालें',
      subscribe: 'सब्सक्राइब करें',
      outOfStock: 'स्टॉक में नहीं',
      searchProducts: 'प्रोडक्ट खोजें...',
      allCategories: 'सभी श्रेणियाँ',
      noProducts: 'कोई प्रोडक्ट नहीं मिला',
      price: 'कीमत',
      mrp: 'एमआरपी',
      off: 'छूट',

      // Cart
      yourCart: 'आपकी कार्ट',
      emptyCart: 'आपकी कार्ट खाली है',
      startShopping: 'खरीदारी शुरू करें',
      subtotal: 'उप-योग',
      deliveryFee: 'डिलीवरी शुल्क',
      total: 'कुल',
      placeOrder: 'ऑर्डर करें',
      free: 'मुफ़्त',
      item: 'आइटम',
      items: 'आइटम',
      remove: 'हटाएँ',
      selectDeliverySlot: 'डिलीवरी स्लॉट चुनें',

      // Subscriptions
      mySubscriptions: 'मेरे सब्सक्रिप्शन',
      noSubscriptions: 'कोई सक्रिय सब्सक्रिप्शन नहीं',
      active: 'सक्रिय',
      paused: 'रुका हुआ',
      cancelled: 'रद्द',
      pauseSubscription: 'रोकें',
      resumeSubscription: 'जारी रखें',
      cancelSubscription: 'रद्द करें',

      // Orders
      myOrders: 'मेरे ऑर्डर',
      noOrders: 'अभी कोई ऑर्डर नहीं',
      orderNumber: 'ऑर्डर',
      delivered: 'डिलीवर हो गया',
      confirmed: 'कन्फ़र्म',
      outForDelivery: 'डिलीवरी के लिए निकला',
      pending: 'लंबित',
      paymentMode: 'भुगतान मोड',
      cashOnDelivery: 'कैश ऑन डिलीवरी',
      onlinePayment: 'ऑनलाइन भुगतान',

      // Tracking
      trackOrder: 'ऑर्डर ट्रैक करें',
      noActiveDelivery: 'कोई सक्रिय डिलीवरी नहीं',
      noActiveDeliveryDesc: 'अभी आपका कोई ऑर्डर डिलीवरी पर नहीं है।',
      refresh: 'रिफ़्रेश',
      yourDeliveryPartner: 'आपका डिलीवरी पार्टनर',

      // Profile
      myProfile: 'मेरी प्रोफ़ाइल',
      editProfile: 'प्रोफ़ाइल संपादित करें',
      saveProfile: 'प्रोफ़ाइल सहेजें',
      walletBalance: 'वॉलेट बैलेंस',
      loyaltyPoints: 'लॉयल्टी पॉइंट्स',
      manageAddresses: 'पते प्रबंधित करें',
      addEditAddresses: 'डिलीवरी पते जोड़ें या बदलें',
      logout: 'लॉगआउट',
      logoutConfirm: 'क्या आप लॉगआउट करना चाहते हैं?',

      // Addresses
      myAddresses: 'मेरे पते',
      addAddress: 'नया पता जोड़ें',
      editAddress: 'पता संपादित करें',
      noAddresses: 'कोई सहेजा हुआ पता नहीं',
      addFirstAddress: 'अपना पहला डिलीवरी पता जोड़ें',
      fullAddress: 'पूरा पता',
      landmark: 'लैंडमार्क',
      city: 'शहर',
      pincode: 'पिनकोड',
      state: 'राज्य',
      setDefault: 'डिफ़ॉल्ट बनाएँ',
      defaultAddress: 'डिफ़ॉल्ट',
      save: 'सहेजें',
      delete: 'हटाएँ',
      edit: 'बदलें',
      cancel: 'रद्द करें',

      // Common
      loading: 'लोड हो रहा है...',
      error: 'कुछ गलत हो गया',
      success: 'सफल',
      close: 'बंद करें',
      yes: 'हाँ',
      no: 'नहीं',
      back: 'वापस',
      next: 'आगे',
      language: 'भाषा',
    },
  },
  ta: {
    translation: {
      home: 'முகப்பு',
      products: 'பொருட்கள்',
      subscriptions: 'சந்தா',
      track: 'கண்காணி',
      orders: 'ஆர்டர்கள்',
      profile: 'சுயவிவரம்',
      cart: 'கார்ட்',
      welcome: 'வரவேற்பு',
      categories: 'வகைகள்',
      popularProducts: 'பிரபலமான பொருட்கள்',
      viewAll: 'அனைத்தும் பார்',
      addToCart: 'கார்டில் சேர்',
      subscribe: 'சந்தா செய்',
      searchProducts: 'பொருட்களை தேடு...',
      yourCart: 'உங்கள் கார்ட்',
      emptyCart: 'கார்ட் காலியாக உள்ளது',
      total: 'மொத்தம்',
      placeOrder: 'ஆர்டர் செய்',
      myOrders: 'என் ஆர்டர்கள்',
      myProfile: 'என் சுயவிவரம்',
      logout: 'வெளியேறு',
      language: 'மொழி',
      save: 'சேமி',
      delete: 'நீக்கு',
      edit: 'திருத்து',
      cancel: 'ரத்து',
      loading: 'ஏற்றுகிறது...',
    },
  },
  te: {
    translation: {
      home: 'హోమ్',
      products: 'ఉత్పత్తులు',
      subscriptions: 'సబ్‌స్క్రిప్షన్లు',
      track: 'ట్రాక్',
      orders: 'ఆర్డర్లు',
      profile: 'ప్రొఫైల్',
      cart: 'కార్ట్',
      welcome: 'స్వాగతం',
      categories: 'వర్గాలు',
      addToCart: 'కార్ట్‌లో జోడించు',
      subscribe: 'సబ్‌స్క్రైబ్',
      yourCart: 'మీ కార్ట్',
      total: 'మొత్తం',
      placeOrder: 'ఆర్డర్ చేయండి',
      myOrders: 'నా ఆర్డర్లు',
      myProfile: 'నా ప్రొఫైల్',
      logout: 'లాగ్‌అవుట్',
      language: 'భాష',
      save: 'సేవ్',
      delete: 'తొలగించు',
      cancel: 'రద్దు',
      loading: 'లోడ్ అవుతోంది...',
    },
  },
  kn: {
    translation: {
      home: 'ಮುಖಪುಟ',
      products: 'ಉತ್ಪನ್ನಗಳು',
      subscriptions: 'ಚಂದಾಗಳು',
      track: 'ಟ್ರ್ಯಾಕ್',
      orders: 'ಆರ್ಡರ್‌ಗಳು',
      profile: 'ಪ್ರೊಫೈಲ್',
      cart: 'ಕಾರ್ಟ್',
      welcome: 'ಸ್ವಾಗತ',
      addToCart: 'ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ',
      total: 'ಒಟ್ಟು',
      placeOrder: 'ಆರ್ಡರ್ ಮಾಡಿ',
      myOrders: 'ನನ್ನ ಆರ್ಡರ್‌ಗಳು',
      myProfile: 'ನನ್ನ ಪ್ರೊಫೈಲ್',
      logout: 'ಲಾಗ್‌ಔಟ್',
      language: 'ಭಾಷೆ',
      save: 'ಉಳಿಸಿ',
      delete: 'ಅಳಿಸಿ',
      cancel: 'ರದ್ದುಮಾಡಿ',
      loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    },
  },
  mr: {
    translation: {
      home: 'होम',
      products: 'उत्पादने',
      subscriptions: 'सदस्यता',
      track: 'ट्रॅक',
      orders: 'ऑर्डर',
      profile: 'प्रोफाइल',
      cart: 'कार्ट',
      welcome: 'स्वागत',
      categories: 'श्रेणी',
      popularProducts: 'लोकप्रिय उत्पादने',
      viewAll: 'सर्व पहा',
      shopByCategory: 'श्रेणीनुसार खरेदी करा',
      addToCart: 'कार्टमध्ये जोडा',
      subscribe: 'सदस्यता घ्या',
      outOfStock: 'स्टॉक नाही',
      searchProducts: 'उत्पादने शोधा...',
      allCategories: 'सर्व श्रेणी',
      noProducts: 'उत्पादने सापडली नाहीत',
      price: 'किंमत',
      yourCart: 'तुमची कार्ट',
      emptyCart: 'तुमची कार्ट रिकामी आहे',
      startShopping: 'खरेदी सुरू करा',
      subtotal: 'उप-एकूण',
      deliveryFee: 'डिलिव्हरी शुल्क',
      total: 'एकूण',
      placeOrder: 'ऑर्डर करा',
      free: 'मोफत',
      item: 'आयटम',
      items: 'आयटम',
      remove: 'काढा',
      selectDeliverySlot: 'डिलिव्हरी स्लॉट निवडा',
      mySubscriptions: 'माझ्या सदस्यता',
      noSubscriptions: 'सक्रिय सदस्यता नाहीत',
      active: 'सक्रिय',
      paused: 'थांबवलेले',
      cancelled: 'रद्द',
      pauseSubscription: 'थांबवा',
      resumeSubscription: 'सुरू करा',
      cancelSubscription: 'रद्द करा',
      myOrders: 'माझे ऑर्डर',
      noOrders: 'अजून ऑर्डर नाहीत',
      orderNumber: 'ऑर्डर',
      delivered: 'डिलिव्हर झाले',
      confirmed: 'पुष्टी',
      outForDelivery: 'डिलिव्हरीसाठी निघाले',
      pending: 'प्रलंबित',
      trackOrder: 'ऑर्डर ट्रॅक करा',
      noActiveDelivery: 'सक्रिय डिलिव्हरी नाही',
      noActiveDeliveryDesc: 'सध्या तुमची कोणतीही ऑर्डर डिलिव्हरीवर नाही.',
      refresh: 'रिफ्रेश',
      yourDeliveryPartner: 'तुमचा डिलिव्हरी पार्टनर',
      myProfile: 'माझी प्रोफाइल',
      editProfile: 'प्रोफाइल संपादित करा',
      saveProfile: 'प्रोफाइल सेव्ह करा',
      walletBalance: 'वॉलेट शिल्लक',
      loyaltyPoints: 'लॉयल्टी पॉइंट्स',
      manageAddresses: 'पत्ते व्यवस्थापित करा',
      addEditAddresses: 'डिलिव्हरी पत्ते जोडा किंवा बदला',
      logout: 'लॉगआउट',
      logoutConfirm: 'तुम्हाला लॉगआउट करायचे आहे का?',
      myAddresses: 'माझे पत्ते',
      addAddress: 'नवा पत्ता जोडा',
      fullAddress: 'पूर्ण पत्ता',
      landmark: 'लँडमार्क',
      city: 'शहर',
      pincode: 'पिनकोड',
      state: 'राज्य',
      setDefault: 'डिफॉल्ट करा',
      defaultAddress: 'डिफॉल्ट',
      save: 'सेव्ह करा',
      delete: 'हटवा',
      edit: 'बदला',
      cancel: 'रद्द करा',
      loading: 'लोड होत आहे...',
      language: 'भाषा',
    },
  },
  ml: {
    translation: {
      home: 'ഹോം',
      products: 'ഉൽപ്പന്നങ്ങൾ',
      subscriptions: 'സബ്സ്ക്രിപ്ഷനുകൾ',
      track: 'ട്രാക്ക്',
      orders: 'ഓർഡറുകൾ',
      profile: 'പ്രൊഫൈൽ',
      cart: 'കാർട്ട്',
      welcome: 'സ്വാഗതം',
      categories: 'വിഭാഗങ്ങൾ',
      popularProducts: 'ജനപ്രിയ ഉൽപ്പന്നങ്ങൾ',
      viewAll: 'എല്ലാം കാണുക',
      shopByCategory: 'വിഭാഗം അനുസരിച്ച് ഷോപ്പ് ചെയ്യുക',
      addToCart: 'കാർട്ടിൽ ചേർക്കുക',
      subscribe: 'സബ്സ്ക്രൈബ് ചെയ്യുക',
      outOfStock: 'സ്റ്റോക്കില്ല',
      searchProducts: 'ഉൽപ്പന്നങ്ങൾ തിരയുക...',
      allCategories: 'എല്ലാ വിഭാഗങ്ങളും',
      noProducts: 'ഉൽപ്പന്നങ്ങൾ കണ്ടെത്തിയില്ല',
      price: 'വില',
      yourCart: 'നിങ്ങളുടെ കാർട്ട്',
      emptyCart: 'നിങ്ങളുടെ കാർട്ട് ശൂന്യമാണ്',
      startShopping: 'ഷോപ്പിംഗ് ആരംഭിക്കുക',
      subtotal: 'ഉപ-ആകെ',
      deliveryFee: 'ഡെലിവറി ഫീ',
      total: 'ആകെ',
      placeOrder: 'ഓർഡർ ചെയ്യുക',
      free: 'സൗജന്യം',
      item: 'ഇനം',
      items: 'ഇനങ്ങൾ',
      remove: 'നീക്കം ചെയ്യുക',
      selectDeliverySlot: 'ഡെലിവറി സ്ലോട്ട് തിരഞ്ഞെടുക്കുക',
      mySubscriptions: 'എന്റെ സബ്സ്ക്രിപ്ഷനുകൾ',
      noSubscriptions: 'സജീവ സബ്സ്ക്രിപ്ഷനുകളില്ല',
      active: 'സജീവം',
      paused: 'താൽക്കാലികമായി നിർത്തി',
      cancelled: 'റദ്ദാക്കി',
      myOrders: 'എന്റെ ഓർഡറുകൾ',
      noOrders: 'ഇതുവരെ ഓർഡറുകളില്ല',
      delivered: 'ഡെലിവർ ചെയ്തു',
      confirmed: 'സ്ഥിരീകരിച്ചു',
      outForDelivery: 'ഡെലിവറിക്ക് പുറപ്പെട്ടു',
      pending: 'തീർപ്പുകൽപ്പിക്കാത്ത',
      trackOrder: 'ഓർഡർ ട്രാക്ക് ചെയ്യുക',
      noActiveDelivery: 'സജീവ ഡെലിവറി ഇല്ല',
      noActiveDeliveryDesc: 'നിലവിൽ ഡെലിവറിയിൽ ഓർഡറുകളൊന്നുമില്ല.',
      refresh: 'റിഫ്രഷ്',
      yourDeliveryPartner: 'നിങ്ങളുടെ ഡെലിവറി പങ്കാളി',
      myProfile: 'എന്റെ പ്രൊഫൈൽ',
      walletBalance: 'വാലറ്റ് ബാലൻസ്',
      loyaltyPoints: 'ലോയൽറ്റി പോയിന്റുകൾ',
      manageAddresses: 'വിലാസങ്ങൾ നിയന്ത്രിക്കുക',
      addEditAddresses: 'ഡെലിവറി വിലാസങ്ങൾ ചേർക്കുക അല്ലെങ്കിൽ മാറ്റുക',
      logout: 'ലോഗൗട്ട്',
      logoutConfirm: 'ലോഗൗട്ട് ചെയ്യണോ?',
      myAddresses: 'എന്റെ വിലാസങ്ങൾ',
      addAddress: 'പുതിയ വിലാസം ചേർക്കുക',
      fullAddress: 'മുഴുവൻ വിലാസം',
      landmark: 'ലാൻഡ്മാർക്ക്',
      city: 'നഗരം',
      pincode: 'പിൻകോഡ്',
      state: 'സംസ്ഥാനം',
      save: 'സേവ്',
      delete: 'ഇല്ലാതാക്കുക',
      edit: 'തിരുത്തുക',
      cancel: 'റദ്ദാക്കുക',
      loading: 'ലോഡ് ചെയ്യുന്നു...',
      language: 'ഭാഷ',
    },
  },
  gu: {
    translation: {
      home: 'હોમ',
      products: 'ઉત્પાદનો',
      subscriptions: 'સબ્સ્ક્રિપ્શન',
      track: 'ટ્રૅક',
      orders: 'ઓર્ડર',
      profile: 'પ્રોફાઇલ',
      cart: 'કાર્ટ',
      welcome: 'સ્વાગત',
      categories: 'શ્રેણીઓ',
      popularProducts: 'લોકપ્રિય ઉત્પાદનો',
      viewAll: 'બધું જુઓ',
      shopByCategory: 'શ્રેણી પ્રમાણે ખરીદી કરો',
      addToCart: 'કાર્ટમાં ઉમેરો',
      subscribe: 'સબ્સ્ક્રાઇબ કરો',
      outOfStock: 'સ્ટોકમાં નથી',
      searchProducts: 'ઉત્પાદનો શોધો...',
      allCategories: 'બધી શ્રેણીઓ',
      noProducts: 'કોઈ ઉત્પાદનો મળ્યા નથી',
      price: 'કિંમત',
      yourCart: 'તમારી કાર્ટ',
      emptyCart: 'તમારી કાર્ટ ખાલી છે',
      startShopping: 'ખરીદી શરૂ કરો',
      subtotal: 'પેટા-કુલ',
      deliveryFee: 'ડિલિવરી ફી',
      total: 'કુલ',
      placeOrder: 'ઓર્ડર કરો',
      free: 'મફત',
      item: 'આઇટમ',
      items: 'આઇટમ',
      remove: 'દૂર કરો',
      selectDeliverySlot: 'ડિલિવરી સ્લોટ પસંદ કરો',
      mySubscriptions: 'મારા સબ્સ્ક્રિપ્શન',
      noSubscriptions: 'કોઈ સક્રિય સબ્સ્ક્રિપ્શન નથી',
      active: 'સક્રિય',
      paused: 'થોભાવેલું',
      cancelled: 'રદ',
      myOrders: 'મારા ઓર્ડર',
      noOrders: 'હજુ સુધી કોઈ ઓર્ડર નથી',
      delivered: 'ડિલિવર થયું',
      confirmed: 'પુષ્ટિ',
      outForDelivery: 'ડિલિવરી માટે નીકળ્યું',
      pending: 'બાકી',
      trackOrder: 'ઓર્ડર ટ્રૅક કરો',
      noActiveDelivery: 'સક્રિય ડિલિવરી નથી',
      noActiveDeliveryDesc: 'હાલમાં તમારો કોઈ ઓર્ડર ડિલિવરી પર નથી.',
      refresh: 'રિફ્રેશ',
      yourDeliveryPartner: 'તમારા ડિલિવરી પાર્ટનર',
      myProfile: 'મારી પ્રોફાઇલ',
      walletBalance: 'વૉલેટ બેલેન્સ',
      loyaltyPoints: 'લોયલ્ટી પોઇન્ટ્સ',
      manageAddresses: 'સરનામાં મેનેજ કરો',
      addEditAddresses: 'ડિલિવરી સરનામાં ઉમેરો અથવા બદલો',
      logout: 'લૉગઆઉટ',
      logoutConfirm: 'શું તમે લૉગઆઉટ કરવા માંગો છો?',
      myAddresses: 'મારા સરનામાં',
      addAddress: 'નવું સરનામું ઉમેરો',
      fullAddress: 'સંપૂર્ણ સરનામું',
      landmark: 'લેન્ડમાર્ક',
      city: 'શહેર',
      pincode: 'પિનકોડ',
      state: 'રાજ્ય',
      save: 'સેવ કરો',
      delete: 'ડિલીટ કરો',
      edit: 'બદલો',
      cancel: 'રદ કરો',
      loading: 'લોડ થઈ રહ્યું છે...',
      language: 'ભાષા',
    },
  },
  bn: {
    translation: {
      home: 'হোম',
      products: 'পণ্য',
      subscriptions: 'সাবস্ক্রিপশন',
      track: 'ট্র্যাক',
      orders: 'অর্ডার',
      profile: 'প্রোফাইল',
      cart: 'কার্ট',
      welcome: 'স্বাগতম',
      categories: 'বিভাগ',
      popularProducts: 'জনপ্রিয় পণ্য',
      viewAll: 'সব দেখুন',
      shopByCategory: 'বিভাগ অনুসারে কিনুন',
      addToCart: 'কার্টে যোগ করুন',
      subscribe: 'সাবস্ক্রাইব করুন',
      outOfStock: 'স্টকে নেই',
      searchProducts: 'পণ্য খুঁজুন...',
      allCategories: 'সব বিভাগ',
      noProducts: 'কোনো পণ্য পাওয়া যায়নি',
      price: 'দাম',
      yourCart: 'আপনার কার্ট',
      emptyCart: 'আপনার কার্ট খালি',
      startShopping: 'কেনাকাটা শুরু করুন',
      subtotal: 'উপ-মোট',
      deliveryFee: 'ডেলিভারি ফি',
      total: 'মোট',
      placeOrder: 'অর্ডার করুন',
      free: 'বিনামূল্যে',
      item: 'আইটেম',
      items: 'আইটেম',
      remove: 'সরান',
      selectDeliverySlot: 'ডেলিভারি স্লট নির্বাচন করুন',
      mySubscriptions: 'আমার সাবস্ক্রিপশন',
      noSubscriptions: 'কোনো সক্রিয় সাবস্ক্রিপশন নেই',
      active: 'সক্রিয়',
      paused: 'বিরতি',
      cancelled: 'বাতিল',
      myOrders: 'আমার অর্ডার',
      noOrders: 'এখনো কোনো অর্ডার নেই',
      delivered: 'ডেলিভার হয়েছে',
      confirmed: 'নিশ্চিত',
      outForDelivery: 'ডেলিভারির জন্য বের হয়েছে',
      pending: 'মুলতুবি',
      trackOrder: 'অর্ডার ট্র্যাক করুন',
      noActiveDelivery: 'সক্রিয় ডেলিভারি নেই',
      noActiveDeliveryDesc: 'এখন আপনার কোনো অর্ডার ডেলিভারিতে নেই।',
      refresh: 'রিফ্রেশ',
      yourDeliveryPartner: 'আপনার ডেলিভারি পার্টনার',
      myProfile: 'আমার প্রোফাইল',
      walletBalance: 'ওয়ালেট ব্যালেন্স',
      loyaltyPoints: 'লয়ালটি পয়েন্ট',
      manageAddresses: 'ঠিকানা পরিচালনা করুন',
      addEditAddresses: 'ডেলিভারি ঠিকানা যোগ বা পরিবর্তন করুন',
      logout: 'লগআউট',
      logoutConfirm: 'আপনি কি লগআউট করতে চান?',
      myAddresses: 'আমার ঠিকানা',
      addAddress: 'নতুন ঠিকানা যোগ করুন',
      fullAddress: 'সম্পূর্ণ ঠিকানা',
      landmark: 'ল্যান্ডমার্ক',
      city: 'শহর',
      pincode: 'পিনকোড',
      state: 'রাজ্য',
      save: 'সেভ করুন',
      delete: 'মুছুন',
      edit: 'সম্পাদনা',
      cancel: 'বাতিল',
      loading: 'লোড হচ্ছে...',
      language: 'ভাষা',
    },
  },
  or: {
    translation: {
      home: 'ହୋମ',
      products: 'ଉତ୍ପାଦ',
      subscriptions: 'ସବସ୍କ୍ରିପସନ',
      track: 'ଟ୍ରାକ',
      orders: 'ଅର୍ଡର',
      profile: 'ପ୍ରୋଫାଇଲ',
      cart: 'କାର୍ଟ',
      welcome: 'ସ୍ୱାଗତ',
      categories: 'ବିଭାଗ',
      popularProducts: 'ଲୋକପ୍ରିୟ ଉତ୍ପାଦ',
      viewAll: 'ସବୁ ଦେଖନ୍ତୁ',
      addToCart: 'କାର୍ଟରେ ଯୋଡ଼ନ୍ତୁ',
      subscribe: 'ସବସ୍କ୍ରାଇବ କରନ୍ତୁ',
      searchProducts: 'ଉତ୍ପାଦ ଖୋଜନ୍ତୁ...',
      noProducts: 'କୌଣସି ଉତ୍ପାଦ ମିଳିଲା ନାହିଁ',
      price: 'ମୂଲ୍ୟ',
      yourCart: 'ଆପଣଙ୍କ କାର୍ଟ',
      emptyCart: 'ଆପଣଙ୍କ କାର୍ଟ ଖାଲି ଅଛି',
      total: 'ମୋଟ',
      placeOrder: 'ଅର୍ଡର କରନ୍ତୁ',
      free: 'ମାଗଣା',
      myOrders: 'ମୋ ଅର୍ଡର',
      noOrders: 'ଏଯାବତ୍ କୌଣସି ଅର୍ଡର ନାହିଁ',
      delivered: 'ଡେଲିଭର ହୋଇଛି',
      confirmed: 'ନିଶ୍ଚିତ',
      outForDelivery: 'ଡେଲିଭରି ପାଇଁ ବାହାରିଛି',
      trackOrder: 'ଅର୍ଡର ଟ୍ରାକ କରନ୍ତୁ',
      noActiveDelivery: 'ସକ୍ରିୟ ଡେଲିଭରି ନାହିଁ',
      myProfile: 'ମୋ ପ୍ରୋଫାଇଲ',
      walletBalance: 'ୱାଲେଟ ବ୍ୟାଲାନ୍ସ',
      loyaltyPoints: 'ଲୟାଲଟି ପଏଣ୍ଟ',
      manageAddresses: 'ଠିକଣା ପରିଚାଳନା କରନ୍ତୁ',
      logout: 'ଲଗଆଉଟ',
      myAddresses: 'ମୋ ଠିକଣା',
      addAddress: 'ନୂଆ ଠିକଣା ଯୋଡ଼ନ୍ତୁ',
      fullAddress: 'ସମ୍ପୂର୍ଣ୍ଣ ଠିକଣା',
      city: 'ସହର',
      pincode: 'ପିନକୋଡ',
      state: 'ରାଜ୍ୟ',
      save: 'ସେଭ କରନ୍ତୁ',
      delete: 'ବାହାର କରନ୍ତୁ',
      edit: 'ସଂପାଦନା',
      cancel: 'ରଦ୍ଦ',
      loading: 'ଲୋଡ ହେଉଛି...',
      language: 'ଭାଷା',
    },
  },
  as: {
    translation: {
      home: 'হোম',
      products: 'সামগ্ৰী',
      subscriptions: 'চাবস্ক্ৰিপচন',
      track: 'ট্ৰেক',
      orders: 'অৰ্ডাৰ',
      profile: 'প্ৰ\'ফাইল',
      cart: 'কাৰ্ট',
      welcome: 'স্বাগতম',
      categories: 'শ্ৰেণী',
      popularProducts: 'জনপ্ৰিয় সামগ্ৰী',
      viewAll: 'সকলো চাওক',
      addToCart: 'কাৰ্টত যোগ কৰক',
      subscribe: 'চাবস্ক্ৰাইব কৰক',
      searchProducts: 'সামগ্ৰী বিচাৰক...',
      noProducts: 'কোনো সামগ্ৰী পোৱা নগ\'ল',
      price: 'দাম',
      yourCart: 'আপোনাৰ কাৰ্ট',
      emptyCart: 'আপোনাৰ কাৰ্ট খালী',
      total: 'মুঠ',
      placeOrder: 'অৰ্ডাৰ কৰক',
      free: 'বিনামূলীয়া',
      myOrders: 'মোৰ অৰ্ডাৰ',
      noOrders: 'এতিয়ালৈকে কোনো অৰ্ডাৰ নাই',
      delivered: 'ডেলিভাৰ হৈছে',
      confirmed: 'নিশ্চিত',
      outForDelivery: 'ডেলিভাৰীৰ বাবে ওলাইছে',
      trackOrder: 'অৰ্ডাৰ ট্ৰেক কৰক',
      noActiveDelivery: 'সক্ৰিয় ডেলিভাৰী নাই',
      myProfile: 'মোৰ প্ৰ\'ফাইল',
      walletBalance: 'ৱালেট বেলেঞ্চ',
      loyaltyPoints: 'লয়ালটি পইণ্ট',
      manageAddresses: 'ঠিকনা পৰিচালনা কৰক',
      logout: 'লগআউট',
      myAddresses: 'মোৰ ঠিকনা',
      addAddress: 'নতুন ঠিকনা যোগ কৰক',
      fullAddress: 'সম্পূৰ্ণ ঠিকনা',
      city: 'চহৰ',
      pincode: 'পিনকোড',
      state: 'ৰাজ্য',
      save: 'ছেভ কৰক',
      delete: 'মচক',
      edit: 'সম্পাদনা',
      cancel: 'বাতিল',
      loading: 'ল\'ড হৈ আছে...',
      language: 'ভাষা',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('app_language') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
